import React from "react";
import { useTranslation } from "react-i18next";
import Pagination from '@/shared/components/AppPagination'
import { useCurrentTool } from "@/shared/hooks/useCurrentTool"

function ReportsPagination({ 
  selectedTabReports, 
  pageSize, 
  page, 
  setPage, 
}) {
  const { t } = useTranslation();
  const { gen_name_plural } = useCurrentTool();
  
  const startRange = (page - 1) * pageSize + 1;
  const totalCount = selectedTabReports?.totalCount || 0;
  const endRange = Math.min(page * pageSize, totalCount);

  const paginationInfo = (
    <div className="text-[#868C98] text-sm sm:items-center overflow-hidden">
      <p className="mr-2 whitespace-nowrap overflow-hidden font-SuisseIntlLight font-medium">
        {t('reports.pagination', {
          startRange,
          endRange,
          totalCount,
          generation_name: gen_name_plural
        })}
      </p>
    </div>
  );

  if (selectedTabReports?.totalCount > pageSize) {
    return (
      <div className={`flex flex-col-reverse gap-1 sm:flex-row justify-between items-center md:items-center w-full pt-3`}>
        {paginationInfo}
        <Pagination
          total={selectedTabReports.totalCount}
          totalPages={Math.ceil(selectedTabReports?.totalCount / pageSize)}
          pageSize={pageSize}
          page={page}
          setPage={setPage}
          className="mt-2 sm:mt-0 flex justify-center"
        />
      </div>
    );
  }

  return (
    <div className={`flex-col sm:flex-row flex w-full justify-between items-center md:items-center mt-4`}>
      <div className="text-[#868C98] text-sm sm:items-center overflow-hidden float-left">
        <p className="mr-2 whitespace-nowrap font-SuisseIntlLight font-medium text-[#71717A] text-[13.56px]">
          {t('reports.pagination', {
            startRange,
            endRange,
            totalCount,
            generation_name: gen_name_plural
          })}
        </p>
      </div>
    </div>
  );
}

export default ReportsPagination;
